import React, { useState } from "react";
import supabase from "../supabaseClient";
import "../styles/global.css";

function Login() {
  const [errorMessage, setErrorMessage] = useState("");

  const redirectTo = (path) => {
    window.location.href = path;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const email = event.target.username.value;
    const password = event.target.password.value;

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        throw error;
      }

      if (data.user) {
        window.location.href = "/home";
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrorMessage(
        error.message || "An error occurred during login. Please try again."
      );
    }
  };
  /*<div>
        <div className="container">
          <h2>Log In to ___</h2>
          <form id="loginForm" onSubmit={handleSubmit}>
            <label htmlFor="username">Email</label>{" "}
            {/* Supabase uses email for login 
            <input type="email" id="username" name="username" required />
            <label htmlFor="password">Password</label>
            <input type="password" id="password" name="password" required />
            <button type="submit" className="button">
              Log In
            </button>
            {errorMessage && <p className="error-message">{errorMessage}</p>}
          </form>
        </div>
      </div>*/

  return (
    <>
      <div className="container">
        <h1>NÄTUR</h1>
        <form id="loginForm" onSubmit={handleSubmit}>
          <div style={{ textAlign: "left", margin: "auto", width: "200px" }}>
            <label htmlFor="username">Username</label>
            <input
              type="text"
              className="form-control"
              placeholder="username"
              name="username"
            />
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="password"
              name="password"
            />
          </div>

          <br />
          <button type="submit" className="btn btn-custom">
            Login
          </button>
          <br />
          <button
            type="button"
            className="btn btn-custom"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            {"<-"} Back
          </button>
        </form>
        <br></br>
      </div>
    </>
  );
}

export default Login;
